const SKIP_BANNER_SESSION_KEY = 'gardenhub:skip-email-verification-banner';
const DISMISSED_PREFIX = 'gardenhub:email-verification-banner-dismissed:';

export function markSkipVerificationBannerForSession(userId: string): void {
	if (typeof window === 'undefined' || !userId) return;
	try {
		window.sessionStorage.setItem(SKIP_BANNER_SESSION_KEY, userId);
	} catch {}
}

export function clearSkipVerificationBanner(): void {
	if (typeof window === 'undefined') return;
	try {
		window.sessionStorage.removeItem(SKIP_BANNER_SESSION_KEY);
	} catch {}
}

export function isVerificationBannerDismissed(userId: string): boolean {
	if (typeof window === 'undefined' || !userId) return false;
	try {
		return window.localStorage.getItem(`${DISMISSED_PREFIX}${userId}`) === '1';
	} catch {
		return false;
	}
}

export function dismissVerificationBanner(userId: string): void {
	if (typeof window === 'undefined' || !userId) return;
	try {
		window.localStorage.setItem(`${DISMISSED_PREFIX}${userId}`, '1');
	} catch {}
}

export function clearVerificationBannerDismissed(userId: string): void {
	if (typeof window === 'undefined' || !userId) return;
	try {
		window.localStorage.removeItem(`${DISMISSED_PREFIX}${userId}`);
	} catch {}
}

export function shouldShowVerificationBanner(userId: string, emailVerified: boolean | undefined): boolean {
	if (!userId || emailVerified) return false;
	if (typeof window === 'undefined') return false;
	try {
		if (window.sessionStorage.getItem(SKIP_BANNER_SESSION_KEY) === userId) return false;
	} catch {}
	return !isVerificationBannerDismissed(userId);
}
